import Training from "pages/training/Training";
import { Route } from "react-router-dom";

const routes = {
  key: "TRAINING",
  routes: ({ userScope }) => [
    <Route
      key="training"
      path={`${userScope}/training`}
      element={<Training />}
    />,
  ],
};
export default routes;
